export const es = {
  hello: "Hola",
  welcomeMessage: "Bienvenido a nuestro sitio web",
};
